module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-app-polyfill/node_modules/core-js/internals/is-pure.js
// module id = 69
// module chunks = 1